import React, { useState, useEffect } from "react";
import { Container, Navbar, NavDropdown, Form, Nav, Button, Image } from "react-bootstrap";
import { Link, NavLink } from "react-router-dom";
import { useTheme } from "../../contexts/ThemeContext";
import { motion } from "framer-motion";

// img
import TopLogoDark from "../../images/logo-dark.png";
import TopLogoDarkSm from "../../images/logo-sm.svg";
import TopLogoLight from "../../images/reshto-logo-1.png";
import TopLogoLightSm from "../../images/logo-sm-light.png";

const TopMenu = () => {
    // State for Sticky Navbar
    const [stickyClass, setStickyClass] = useState("");
    const { theme, toggleTheme } = useTheme();

    // Favorite items count from localStorage
    const [favCount, setFavCount] = useState(() => {
        const saved = localStorage.getItem('favorite_items');
        return saved ? JSON.parse(saved).length : 0;
    });

    const [cartCount, setCartCount] = useState(() => {
        const saved = localStorage.getItem('cart_items');
        const items = saved ? JSON.parse(saved) : [];
        return items.reduce((sum, item) => sum + (item.quantity || 1), 0);
    });

    useEffect(() => {
        const stickNavbar = () => {
            const windowHeight = window.scrollY;
            setStickyClass(windowHeight > 0 ? "sticky-nav" : "");
        };

        // Sync favorite and cart counts across components
        const handleStorageChange = () => {
            const favSaved = localStorage.getItem('favorite_items');
            setFavCount(favSaved ? JSON.parse(favSaved).length : 0);

            const cartSaved = localStorage.getItem('cart_items');
            const items = cartSaved ? JSON.parse(cartSaved) : [];
            setCartCount(items.reduce((sum, item) => sum + (item.quantity || 1), 0));
        };

        window.addEventListener("scroll", stickNavbar);
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('localStorageChange', handleStorageChange);
        return () => {
            window.removeEventListener("scroll", stickNavbar);
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('localStorageChange', handleStorageChange);
        };
    }, []);

    // Menu close in responsive
    const [expanded, setExpanded] = useState(false);
    const handleClose = () => setExpanded(false);

    return (
        <>
            <motion.div className='top-custom-menu' initial={{ opacity: 0, y: 50 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.5 }}>
                <Navbar collapseOnSelect expanded={expanded} expand="lg" className={stickyClass} >
                    <Container>
                        <Link to="/home" className='topbar-logo'>
                           {
                            theme === 'light' ? (
                                <>
                                <Image src={TopLogoDark} alt="" className='logo-dark d-sm-block d-none' height={34} />
                                <Image src={TopLogoDarkSm} alt="" className='logo-dark d-sm-none d-block' height={34} />
                                </>
                            ) : (
                                <>
                                <Image src={TopLogoLight} alt="" className='logo-dark d-sm-block d-none' height={34} />
                                <Image src={TopLogoLightSm} alt="" className='logo-dark d-sm-none d-block' height={34} />
                                </>
                            )
                           }
                        </Link>
                        <motion.div className='top-menu-sm-tool d-flex d-lg-none' initial={{ opacity: 0 , y: 50 }} animate={{ opacity: 1 , y: 0 }} transition={{ duration: 0.5 }}>
                            <Nav className='top-right-nav ms-lg-auto ms-xl-0 mt-2 mt-lg-0 mb-3 mb-lg-0'>
                                <NavDropdown className='menu-search' align={{ lg: 'end' }} title={<>
                                    <i className="ri-search-2-line"></i>
                                </>
                                } id="basic-nav-dropdown">
                                    <Form>
                                        <Form.Group className="">
                                            <Form.Control type="text" placeholder="Search..." />
                                        </Form.Group>
                                    </Form>
                                </NavDropdown>
                                <Button variant="link" className="nav-link p-0" onClick={toggleTheme} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
                                        {theme === 'light' ? (
                                            <i className="ri-moon-line"></i>
                                        ) : (
                                            <i className="ri-sun-line"></i>
                                        )}
                                    </Button>
                                <Link to="/favorite" className='nav-link topmenu-fav-icon'>{favCount > 0 && <span className='top-fav-items'>{favCount}</span>}<i className="ri-heart-line"></i></Link>
                                <Link to="/cart" className='nav-link topmenu-cart-icon'>{cartCount > 0 && <span className='top-cart-items'>{cartCount}</span>}<i className="ri-shopping-cart-line"></i></Link>
                                <NavDropdown align={{ lg: 'end' }} title={<i className="ri-user-line"></i>} id="user-dropdown" className="nav-user-icon">
                                    <Link to="/" className='dropdown-item'>Login</Link>
                                </NavDropdown>
                            </Nav>
                            <Navbar.Toggle aria-controls="responsive-navbar-nav" onClick={() => setExpanded(expanded ? false : true)} />
                        </motion.div>
                        <Navbar.Collapse id="responsive-navbar-nav">
                            <Nav className="mx-lg-auto">
                                <NavLink to="/home" exact="true" className="nav-link" activeclassname="active" onClick={handleClose}>Home</NavLink>
                                <NavLink to="/about_us" className="nav-link" activeclassname="active" onClick={handleClose}>About Us</NavLink>
                                <NavLink to="/food_menu" className="nav-link" activeclassname="active" onClick={handleClose}>Menu</NavLink>
                                <NavLink to="/chefs" className="nav-link" activeclassname="active" onClick={handleClose}>Chefs</NavLink>
                                <NavLink to="/contact" className="nav-link" activeclassname="active" onClick={handleClose}>Contact Us</NavLink>
                            </Nav>
                            <Nav className='top-right-nav ms-lg-auto ms-xl-0 mt-2 mt-lg-0 mb-3 mb-lg-0 d-none d-lg-flex'>
                                <NavDropdown className='menu-search' align={{ lg: 'end' }} title={<>
                                    <i className="ri-search-2-line"></i>
                                </>
                                } id="basic-nav-dropdown">
                                    <Form>
                                        <Form.Group className="">
                                            <Form.Control type="text" placeholder="Search..." />
                                        </Form.Group>
                                    </Form>
                                </NavDropdown>
                                    <Button variant="link" className="nav-link p-0" onClick={toggleTheme} aria-label={`Switch to ${theme === 'light' ? 'dark' : 'light'} mode`}>
                                        {theme === 'light' ? (
                                            <i className="ri-moon-line"></i>
                                        ) : (
                                            <i className="ri-sun-line"></i>
                                        )}
                                    </Button>
                                <Link to="/favorite" className='nav-link topmenu-fav-icon'>{favCount > 0 && <span className='top-fav-items'>{favCount}</span>}<i className="ri-heart-line"></i></Link>
                                <Link to="/cart" className='nav-link topmenu-cart-icon'>{cartCount > 0 && <span className='top-cart-items'>{cartCount}</span>}<i className="ri-shopping-cart-line"></i></Link>
                                <NavDropdown align={{ lg: 'end' }} title={<i className="ri-user-line"></i>} id="user-dropdown" className="nav-user-icon">
                                    <Link to="/" className='dropdown-item'>Login</Link>
                                </NavDropdown>
                            </Nav>
                        </Navbar.Collapse>
                    </Container>
                </Navbar>
            </motion.div>
        </>
    )
}

export default TopMenu;
